import { render, staticRenderFns } from "./VoiceMessage.vue?vue&type=template&id=27bd9224"
import script from "./VoiceMessage.vue?vue&type=script&lang=js"
export * from "./VoiceMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports